import moment from 'moment';
import 'moment/locale/es';
import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { FiUserPlus } from 'react-icons/fi';
import { UserCreateForm } from '../forms/UserCreateForm';
moment.locale('es');

const CreateModal = ({ setModalShow, modalShow, roles, branchOffices }) => {
  return (
    <Modal
      show={modalShow}
      onHide={() => {
        setModalShow(false);
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="fw-light">
          <FiUserPlus /> Nuevo Usuario
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <UserCreateForm
          roles={roles}
          branchOffices={branchOffices}
          setModalShow={setModalShow}
        />
      </Modal.Body>
    </Modal>
  );
};

CreateModal.propTypes = {
  modalShow: PropTypes.bool.isRequired,
  setModalShow: PropTypes.func.isRequired,
  roles: PropTypes.array.isRequired,
  branchOffices: PropTypes.array.isRequired
};

export default CreateModal;
